import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {LayoutFullWidth} from "../../../../Components/Layout";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {braillerLoanApi} from "../BraillerLoan/braillerLoanApi";
import {BraillerHistoryView} from "./BraillerHistoryView";
import {BraillerHistorySearchFormView} from "./BraillerHistorySearchFormView";
import {braillerHistory} from "./braillerHistoryFactory";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";

export const BraillerHistoryContainer = ({
                                             handleApiCall,
                                             handleSetBraillerHistorySearchCriteria,
                                             isLoading,
                                             braillerHistorySearchCriteria,
                                         }: ContextProps) => {
    const [loanHistories, setLoanHistories] = useState<Record<string, any>[]>([]);
    const [dropDowns, setDropDowns] = useState<Record<string, unknown> | null>(null);
    const [totalRecords, setTotalRecords] = useState(0);

    const loadLoanHistoriesResults = (result: Record<string, any>) => {
        // WebApi returns { items, totalCount, page, pageSize }
        const sourceItems = result?.items ?? [];
        const histories = sourceItems.map((history: Record<string, any>) => braillerHistory(history));
        setLoanHistories(histories);
        setTotalRecords(result?.totalCount ?? 0);
    };

     const handleGetDropDowns = () => {
        handleApiCall(() => braillerLoanApi.getDropdownListsForBraillerLoanSearch(), (results: Record<string, unknown>) => {
            setDropDowns(results)
        });
    };

    useEffect(() => {
        if (!dropDowns) {
            handleGetDropDowns();
        }

        if (braillerHistorySearchCriteria && braillerHistorySearchCriteria.loadSearchResults) {
            handleApiCall(
                () =>
                    braillerLoanApi.getLoanHistory({
                        ...braillerHistorySearchCriteria,
                    }),
                loadLoanHistoriesResults
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [braillerHistorySearchCriteria, dropDowns]);

    const handleExportHistoryClick = () => {
        if (isArrayNullOrEmpty(loanHistories))
            alert("Search criteria has no results. Adjust your search and try again.")
        else
            handleApiCall(() => braillerLoanApi.getBraillerLoanHistoryReport(braillerHistorySearchCriteria));
    };

    if (!braillerHistorySearchCriteria || isNullOrUndefined(dropDowns)) return null;

    return (
        <>
            <PageTitle h1="Brailler History"/>

            {dropDowns && (
                <div className="searchBox">
                    <div className="searchBox__title">Search Loan History</div>
                    <BraillerHistorySearchFormView
                        dropDowns={dropDowns}
                        handleSetSearchCriteria={handleSetBraillerHistorySearchCriteria}
                        isLoading={isLoading}
                        searchCriteria={braillerHistorySearchCriteria}
                    />
                </div>
            )}

            <LayoutFullWidth className="catalog">
                <header>
                    <h2>Loan History Results</h2>
                </header>

                <GridContainer isReverseOrder hasMarginX className={`form__header`}>
                    <GridCell
                        medium_columns={gridConstants.column.ONE}>
                        <ButtonLinkStyle
                            isCollapsed
                            label={`Export Brailler History`}
                            name="btnExportHistory"
                            onClick={handleExportHistoryClick}
                        />
                    </GridCell>
                </GridContainer>

                <BraillerHistoryView
                    handleSetSearchCriteria={handleSetBraillerHistorySearchCriteria}
                    loanHistories={loanHistories}
                    searchCriteria={braillerHistorySearchCriteria}
                    totalRecords={totalRecords}
                    onExportClick={handleExportHistoryClick}
                />
            </LayoutFullWidth>
        </>
    );
};
